import React, { useState } from 'react'
import { Button } from '@CommonComponents/buttons'
import MEModal from '../../components/MEModal'
import { VideoChapter } from './VideoChapter'
import { forceVideoAnalytics } from '../actions'
import { toast } from '@CommonComponents/toast'

export const forceVideoItem = {
  id: 'force-video',
  label: 'Force Video',
  icon: 'fa-light fa-video',
}

export const ForceVideoModal = ({
  user_id,
  user_full_name,
  videoData,
  show,
  close,
}) => {
  const [videos, setVideos] = useState([])

  const handleChange = (e) => {
    if (videos.includes(e.target.value)) {
      setVideos(videos.filter(vid => vid !== e.target.value))
    } else {
      setVideos([...videos, e.target.value])
    }
  }

  const submitAnalytics = async () => {
    let cmVids = {
      cmId: user_id,
      videos: videos,
    }
    close()
    let resp = await forceVideoAnalytics(cmVids)

    if (resp.status === 204) {
      toast.success(`Analytics Updated - Successfully forced analytics for ${user_full_name}.`)
    } else {
      toast.error(`There was an error trying to force analytics. ${resp.message}`)
    }
  }

  return (
    <MEModal show={show} close={close} title="Record Video Completion">
      <div>
        {videoData.map(chapter => (
          <VideoChapter
            chapter={chapter}
            key={chapter[0]}
            handleChange={handleChange}
          />
        ))}
        <div className="text-center">
          <Button
            className="mt-5 mx-auto me-btn me-btn-primary"
            type="button"
            onClick={submitAnalytics}
          >
            Record video completion
          </Button>
        </div>
      </div>
    </MEModal>
  )
}
